export interface UpdateSeparateDictionaryRequest {
  id: number
  name: string
  separateName: string
  revision: number
}

export function UpdateSeparateDictionaryRequestToJSON(
  value: UpdateSeparateDictionaryRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    name: value.name !== '' ? value.name : undefined,
    separate_name: value.separateName !== '' ? value.separateName : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
